/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiAssignmentUser
 */
export interface ApiAssignmentUser {
    /**
     * 
     * @type {number}
     * @memberof ApiAssignmentUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApiAssignmentUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssignmentUser
     */
    name?: string;
}

/**
 * Check if a given object implements the ApiAssignmentUser interface.
 */
export function instanceOfApiAssignmentUser(value: object): value is ApiAssignmentUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ApiAssignmentUserFromJSON(json: any): ApiAssignmentUser {
    return ApiAssignmentUserFromJSONTyped(json, false);
}

export function ApiAssignmentUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAssignmentUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ApiAssignmentUserToJSON(json: any): ApiAssignmentUser {
    return ApiAssignmentUserToJSONTyped(json, false);
}

export function ApiAssignmentUserToJSONTyped(value?: ApiAssignmentUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
    };
}

